
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4A5oU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $352611435be8cd6d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $352611435be8cd6d$export$2e2bcd8739ae039 = {
    'fabric.editor.headingLink.ascSortingLabel': 'oplopend',
    'fabric.editor.headingLink.copied': 'Gekopieerd!',
    'fabric.editor.headingLink.copyAnchorLink': "Link naar kop kopi\xebren",
    'fabric.editor.headingLink.copyAriaLabel': "Kopi\xebren",
    'fabric.editor.headingLink.descSortingLabel': 'aflopend',
    'fabric.editor.headingLink.failedToCopy': "Kopi\xebren mislukt",
    'fabric.editor.headingLink.noneSortingLabel': 'Geen',
    'fabric.editor.inlineComment.marker.end': 'einde inline-opmerking',
    'fabric.editor.inlineComment.marker.start': 'begin inline-opmerking'
};

});


//# sourceMappingURL=nl.53a9d6d2.js.map
